// SAVE NA NUVEM.
//
// Mesmo desenho do 38 Brasil, com as tres protecoes que la existem e que so
// aparecem quando o jogo esta no ar de verdade:
//
//   1. VERSAO -- todo envio diz de qual versao partiu. Se a nuvem estiver mais
//      nova (outro aparelho jogou depois), o servidor recusa com 409 e devolve
//      o save remoto em vez de deixar um aparelho apagar o outro.
//   2. FILA -- um envio por vez. Dois envios simultaneos com a mesma versao
//      base geram conflito com a propria pessoa.
//   3. ESPERA -- nao envia a cada rodada. Junta as mudancas e envia depois de
//      parar, senao seriam 82 envios por temporada.

import { pushCloudSave, pullCloudSave, readAccount } from './api.js';

const VERSION_KEY = 'basquete82.nuvem.versao';
const LAST_KEY = 'basquete82.nuvem.quando';
const ESPERA_MS = 4000;

const ler = (k, padrao = null) => {
  try { return localStorage.getItem(k) ?? padrao; } catch { return padrao; }
};
const gravar = (k, v) => { try { localStorage.setItem(k, String(v)); } catch { /* bloqueado */ } };

export const cloudVersion = () => Number(ler(VERSION_KEY, '0')) || 0;
export const cloudLastAt = () => ler(LAST_KEY, null);

let emVoo = null;
let agendado = null;
let ouvintes = [];

/** A tela se inscreve para mostrar o estado da sincronizacao. */
export function onCloudChange(fn) {
  ouvintes.push(fn);
  return () => { ouvintes = ouvintes.filter((f) => f !== fn); };
}
const avisar = (estado) => ouvintes.forEach((f) => f(estado));

export function cloudEnabled() {
  const conta = readAccount();
  return !!(conta?.token && conta?.premium);
}

/**
 * Envia agora. Devolve { ok } ou { conflict, save } -- e quem chamou decide o
 * que fazer com o conflito. Esta funcao NAO resolve conflito sozinha: escolher
 * qual carreira sobrevive e do usuario.
 */
export async function pushNow(save, { force = false } = {}) {
  const conta = readAccount();
  if (!conta?.token) return { ok: false, error: 'Sem conta.' };
  if (emVoo) { try { await emVoo; } catch { /* ignora o anterior */ } }

  avisar({ estado: 'enviando' });
  emVoo = (async () => {
    try {
      const r = await pushCloudSave(conta.token, save, { baseVersion: cloudVersion(), force });
      gravar(VERSION_KEY, r.version);
      gravar(LAST_KEY, r.at);
      avisar({ estado: 'ok', at: r.at, bytes: r.bytes, version: r.version });
      return { ok: true, ...r };
    } catch (err) {
      if (err.conflict) {
        avisar({ estado: 'conflito', remoto: err.payload });
        return { ok: false, conflict: true, remoto: err.payload };
      }
      avisar({ estado: 'erro', error: err.message });
      return { ok: false, error: err.message };
    } finally {
      emVoo = null;
    }
  })();
  return emVoo;
}

/** Junta as mudancas e envia depois que o jogo parar. */
export function pushSoon(save) {
  if (!cloudEnabled()) return;
  clearTimeout(agendado);
  agendado = setTimeout(() => pushNow(save), ESPERA_MS);
}

export async function pullNow() {
  const conta = readAccount();
  if (!conta?.token) return { ok: false, error: 'Sem conta.' };
  avisar({ estado: 'baixando' });
  try {
    const r = await pullCloudSave(conta.token);
    if (r.version) { gravar(VERSION_KEY, r.version); gravar(LAST_KEY, r.at); }
    avisar({ estado: 'ok', at: r.at, bytes: r.bytes, version: r.version });
    return { ok: true, ...r };
  } catch (err) {
    avisar({ estado: 'erro', error: err.message });
    return { ok: false, error: err.message };
  }
}

/** Depois de aceitar o save da nuvem, a versao local passa a ser a de la. */
export function adoptVersion(version, at) {
  gravar(VERSION_KEY, version);
  if (at) gravar(LAST_KEY, at);
}
